import React from "react";
import makeAnimated from "react-select/animated";
import moment from "moment";

// material-ui
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import SearchIcon from "@material-ui/icons/Search";

// styles
import { HeaderTextContainer, selectDateMenuStyles } from "./styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardText from "components/Card/CardText.js";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "components/CustomButtons/Button.js";
import Select from "react-select";

// components
import Datetime from "react-datetime";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { switchFilters } from "redux/ducks/orders";
import { Switch, Box, FormControlLabel } from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import { SelectComponent } from "components/SelectMenu/SelectComponent";
// import Switch from '@mui/material/Switch';

const label = { inputProps: { "aria-label": "Switch demo" } };
const useStyles = makeStyles(selectDateMenuStyles);

const animatedComponents = makeAnimated();
const typeCustomer = [
  { label: "Cliente", value: "CLIENTE" },
  { label: "Publico en general", value: "GENERAL" }
];

const SelectDateMenu = React.memo(
  ({
    color,
    colorRGB,
    dates = { startDate: null, endDate: null },
    hasStations,
    hasUnits,
    hasAgents,
    hasDiff,
    diffName = "",
    diffPlaceholder = "",
    diffLabel = "",
    onlyStations,
    stations = [],
    units = [],
    diffs = [],
    optionSelected = [],
    unitSelected = [],
    diffSelected = [],
    customer = "",
    onChangeInputCustomer,
    onChangeStartDate,
    onChangeEndDate,
    onChangeFilter,
    onChangeFilterUnits,
    onChangeFilterDiff,
    onSubmit,
    disabled = false,
    agent = false,
    publicGeneral = false,
    topLabel,
    download = "",
    isMultiOne = true,
    isMultiTwo = true,
    isMultiDiff = true,
    byDay = false,
    isByStationary = false,
    filterByType = false,
    typesData = [],
    typeRoute = {},
    onChangeType
  }) => {
    const classes = useStyles({ color: colorRGB });
    const { switchState } = useSelector(state => state.orders);
    const dispatch = useDispatch();

    const handleSwitch = () => {
      dispatch(switchFilters());
    };

    var sevenDays = moment(dates.startDate).add(7, "day");
    const valid = current =>
      current.isBefore(sevenDays) && current.isSameOrAfter(dates.startDate);

    var today = moment().endOf("day");

    return (
      <React.Fragment>
        <GridContainer className={classes.grid}>
          <GridItem className={classes.gridNoPadding} xs={12} sm={12} md={12}>
            <Card className={classes.cardHover}>
              <CardHeader color={color} text>
                <CardText className={classes.cardHeader} color={color}>
                  <HeaderTextContainer>
                    <SearchIcon />
                    <h5 className={classes.cardTitle}>
                      {topLabel ? topLabel : "Buscar"}
                    </h5>
                  </HeaderTextContainer>
                </CardText>
              </CardHeader>
              <CardBody>
                {!onlyStations && (
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={byDay ? 12 : 6}>
                      <InputLabel className={classes.label}>
                        {byDay ? "Seleccione el dia:" : "Desde:"}
                      </InputLabel>

                      <FormControl fullWidth>
                        <Datetime
                          onChange={onChangeStartDate}
                          timeFormat={false}
                          dateFormat="DD/MM/YYYY"
                          value={dates.startDate}
                          //isValidDate={publicGeneral ? valid : null}
                        />
                      </FormControl>
                    </GridItem>
                    {!byDay && (
                      <GridItem xs={12} sm={6}>
                        <InputLabel className={classes.label}>A:</InputLabel>

                        <FormControl fullWidth>
                          <Datetime
                            onChange={onChangeEndDate}
                            timeFormat={false}
                            dateFormat="DD/MM/YYYY"
                            value={dates.endDate}
                            isValidDate={publicGeneral ? valid : null}
                          />
                        </FormControl>
                      </GridItem>
                    )}
                  </GridContainer>
                )}
                {filterByType && <GridContainer></GridContainer>}
                {publicGeneral && (
                  <GridContainer
                    className={classes.marginRow}
                    justifyContent="center"
                  >
                    <GridItem xs={12} sm={12}>
                      <InputLabel className={classes.label}>
                        {" "}
                        Filtrar por Cliente{" "}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        placeholder="Filtrar por publico general"
                        name="customer"
                        value={customer}
                        components={animatedComponents}
                        options={typeCustomer}
                        onChange={onChangeInputCustomer}
                        className="list-select__container"
                        classNamePrefix="select"
                      />
                    </GridItem>
                  </GridContainer>
                )}
                {hasStations && (
                  <GridContainer
                    className={classes.marginRow}
                    justifyContent="center"
                  >
                    <GridItem xs={12} sm={filterByType ? 9 : 12}>
                      {agent && (
                        <InputLabel
                          htmlFor="simple-select"
                          className={`${classes.selectLabel} ${classes.marginLabelInput}`}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                          }}
                        >
                          {!switchState ? "Plantas" : "Agentes"}:
                          {/* <p onClick={handleSwitch} >Filtrar por: <span style={{
                          color: '#004F9F',
                          cursor: 'pointer'
                        }}>{ switchState  ?'Plantas' : 'Agentes' }</span></p> */}
                          <p style={{ margin: 0 }}>
                            Filtrar por Agentes:
                            <Switch
                              {...label}
                              color="primary"
                              checked={switchState}
                              onChange={handleSwitch}
                            />
                          </p>
                        </InputLabel>
                      )}
                      <div>
                        <InputLabel className={classes.label}>
                          {" "}
                          Seleccione plantas{" "}
                        </InputLabel>
                        <Select
                          isMulti={isMultiOne}
                          // placeholder={`${!switchState ? 'Plantas' : 'Agentes'}...`}
                          // name={`${ !switchState ? 'stations' : 'agents' }`}
                          placeholder={
                            switchState && agent ? "Agentes..." : "Plantas..."
                          }
                          name={switchState && agent ? "agents" : "stations"}
                          value={optionSelected}
                          components={animatedComponents}
                          options={stations}
                          onChange={onChangeFilter}
                          className={
                            !publicGeneral
                              ? "list-select__container z-5"
                              : "list-select__container"
                          }
                          classNamePrefix="select"
                        />
                      </div>
                    </GridItem>
                    {filterByType && (
                      <GridItem xs={12} sm={3}>
                        <InputLabel className={classes.label}>
                          {" "}
                          Seleccione por tipo{" "}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-filled-label"
                          id="demo-simple-select-filled__"
                          placeholder="Seleccione el tipo de Ruta"
                          name="routes"
                          value={typeRoute}
                          components={animatedComponents}
                          options={typesData}
                          onChange={onChangeType}
                          className="list-select__container"
                          classNamePrefix="select"
                        />
                      </GridItem>
                    )}
                  </GridContainer>
                )}
                {hasUnits && (
                  <GridContainer
                    className={classes.marginRow}
                    justifyContent="center"
                  >
                    <GridItem xs={12} sm={12}>
                      <div>
                        <Select
                          isMulti={isMultiTwo}
                          placeholder={"Unidades..."}
                          name={"Unidades"}
                          value={unitSelected}
                          components={animatedComponents}
                          options={units}
                          onChange={onChangeFilterUnits}
                          className="list-select__container z-4"
                          classNamePrefix="select"
                        />
                      </div>
                    </GridItem>
                  </GridContainer>
                )}
                {hasDiff && (
                  <GridContainer
                    className={classes.marginRow}
                    justifyContent="center"
                  >
                    <GridItem xs={12} sm={12}>
                      <div>
                        {diffLabel && (
                          <InputLabel className={classes.label}>
                            {" "}
                            {diffLabel}{" "}
                          </InputLabel>
                        )}
                        <Select
                          isMulti={isMultiDiff}
                          placeholder={diffPlaceholder}
                          name={diffName}
                          value={diffSelected}
                          components={animatedComponents}
                          options={diffs}
                          onChange={onChangeFilterDiff}
                          className="list-select__container z-4"
                          classNamePrefix="select"
                        />
                      </div>
                    </GridItem>
                  </GridContainer>
                )}
                <GridContainer justifyContent="center">
                  <GridItem xs={12} sm={12}>
                    <Button
                      onClick={onSubmit}
                      size="sm"
                      color="info"
                      fullWidth
                      disabled={disabled}
                    >
                      {download
                        ? `Generar ${download.toString().toUpperCase()}`
                        : "Buscar"}
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </React.Fragment>
    );
  }
);

export default SelectDateMenu;
